import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    modals: [],
};

const modalsSlice = createSlice({
    name: 'modals',
    initialState,
    reducers: {
        openModal: (state, action) => {
            state.modals.push(action.payload);
        },
        closeModal: (state, action) => {
            state.modals = state.modals.filter(
                modal => modal.modalId !== action.payload
            );
        },
        closeLastModal: (state) => {
            state.modals.pop();
        },
        closeAllModals: (state) => {
            state.modals = [];
        },
    },
});

export const {
    openModal,
    closeModal,
    closeLastModal,
    closeAllModals,
} = modalsSlice.actions;

export default modalsSlice.reducer;